import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { getVariableFromEnv } from "../../common/utilities/env";

const oidcConfig = {
  authority: getVariableFromEnv("AUTH_DOMAIN"),
  client_id: getVariableFromEnv("AUTH_CLIENT_ID"),
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: window.location.origin,
  scope: "openid profile email offline_access",
  response_type: "code",
  extraQueryParams: {
    audience: getVariableFromEnv("AUTH_AUDIENCE"),
  },
  loadUserInfo: true,
  automaticSilentRenew: false,
  includeIdTokenInSilentRenew: false,
  monitorSession: false,
};

const oidcManager = new UserManager({
  ...oidcConfig,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});
export default oidcManager;
